import React, { Component } from "react";
import { Button, message, Modal } from "antd";

import '../css/widget/widget.modal.css';

class WidgetModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            options: props.options || {},
        }

        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }

    open = () => {

        this.setState({ visible: true });
    }

    onOkClick = (type) => async () => {
        if (this.props.isHide && type === 'onOk') return this.props.onOk();
        if (this.props[type]) this.props[type]();
        if (this.props.options.isVisible && type === 'onCancel') {
            this.props.options.isVisible = false
        }
        await this.setState({ visible: false });
    }

    onClose = () => {
        this.setState({ visible: false, })
        if (this.props.options.isVisible) {
            this.props.options.isVisible = false
        }

        if (this.props.onClose) {
            this.props.onClose()
        }

    }


    render() {

        const { visible, options } = this.state;
        let { title, isVisible, height = '500px', okText = '确定', cancelText = '取消', isOk = true, isCancel = true, modalType = '', width = 800,
            wrapClassName = '', type = '', message = '', bodyStyle = {}, isNext = false, isLast = false, lastText = '上一步', nextText = '下一步' } = this.props.options || {};

        bodyStyle = { 'maxHeight': '800px',  'overflow': 'auto', ...bodyStyle }

        return <div className="swd-modal sfm-modal spj-modal spg-modal">
            <Modal
                // getContainer={false}
                open={isVisible ? isVisible : visible}
                title={title}
                width={width}
                height={height}
                wrapClassName={wrapClassName}
                bodyStyle={{ ...bodyStyle }}
                destroyOnClose={true}
                onOk={this.onOkClick('onOk')}
                onCancel={this.onClose}
                footer={modalType === 'form' ? null : [
                    isLast && <Button type="back" onClick={() => this.props.onOkClick('isLast')}>{lastText}</Button>,
                    isCancel && <Button type="back" onClick={this.onOkClick('onCancel')}>{cancelText}</Button>,
                    isNext && <Button type="primary" onClick={() => this.props.onOkClick('isNext')}>{nextText}</Button>,
                    isOk && <Button type='primary' onClick={this.onOkClick('onOk')}>{okText}</Button>,
                ]}
            >
                {
                    type === 'message' ? <div>{message}</div> : this.props.children
                }
            </Modal>
        </div>
    }
}

export default WidgetModal;